import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { TextBase, TextProps } from './TextBase';
export const TextSmall = React.forwardRef<HTMLDivElement, TextProps>((t0, ref) => {
  const $ = _c(8);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [0.75, 1];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props || $[6] !== ref) {
    t2 = <TextBase ref={ref} sizes={t1} {...props}>{children}</TextBase>;
    $[4] = children;
    $[5] = props;
    $[6] = ref;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
});